import React from 'react';
import PropTypes from 'prop-types';
import BookmarkIcon from '../Icons/BookmarkIcon';
import { savePost, unsavePost } from '../../actions';
import './SaveButton.css';
import { cc } from '../../modules/styles';

/**
 * Button to Save a Post
 */

const SaveButton = ({ postId, saved, className, reddit }) => (
  <button
    className={cc('SaveButton', className)}
    onClick={() => {
      if (saved) {
        unsavePost(reddit, postId);
      } else {
        savePost(reddit, postId);
      }
    }}
    title={saved ? 'Un-save Post' : 'Save Post'}
  >
    <BookmarkIcon
      className={cc(
        'SaveButton__bookmark-icon',
        saved
          ? 'SaveButton__bookmark-icon--saved'
          : 'SaveButton__bookmark-icon--unsaved'
      )}
    />
  </button>
);

SaveButton.propTypes = {
  postId: PropTypes.string.isRequired,
  saved: PropTypes.bool.isRequired,
  reddit: PropTypes.object.isRequired,
};

export default SaveButton;
